import { AdminServiceGridSortColumn } from "@/Administration/Models/Enums/AdminServiceGridSortColumn";
import { IServiceComboGridModel } from "@/Administration/Models/UI/ServiceCombo/IServiceComboGridModel";
import { Service } from "@/Common/Api/Services/Dto/Responses/Service";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { RefreshButton } from "@/Common/Components/Buttons/RefreshButton";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { SettingsButton } from "@/Common/Components/Settings/SettingsButton";
import { SpanControl } from "@/Common/Components/SpanControl";
import { MyleTable } from "@/Common/Components/Tables/MyleTable";
import { MyleTableColumn, MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { IComboOrServiceItem } from "@/Common/Models/Services/BaseServiceDefinitionModel";
import { ServiceComboItemType } from "@/Common/Models/Services/Enums/ServiceComboItemType";
import { ServiceComboDefinitionModel } from "@/Common/Models/Services/ServiceComboDefinitionModel";
import { ServiceDefinitionModel } from "@/Common/Models/Services/ServiceDefinitionModel";
import { ServiceModel } from "@/Common/Models/Services/ServiceModel";
import { ServiceOrComboTableItem } from "@/Common/Models/Services/ServiceOrComboTableItem";
import { EmployeeGroupUIModel } from "@/Common/Models/UI/Employee/EmployeeGroupUIModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { SortDirection } from "@/Common/Models/UI/Enums";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { ITableRenderOptions } from "@/Common/Models/UI/Tables/ITableRenderOptions";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IUserAddNewServiceComboProps {
    editedUser?: EmployeeUIModel;
    editedGroup?: EmployeeGroupUIModel;
    userServiceComboGridModel?: IServiceComboGridModel;
    serviceComboGridModel: IServiceComboGridModel;
    serviceDefinitionCache: Immutable.List<ServiceDefinitionModel>;
    serviceComboDefinitionCache: Immutable.List<ServiceComboDefinitionModel>;
    refreshServiceOperation: number;
    closeOperation: number;
    saveOperation: number;
    closeSearchSettingOperation: number;
    openSearchSettingOperation: number;
}

class UserAddNewServiceComboState {
    public editedUser: EmployeeUIModel;
    public editedGroup: EmployeeGroupUIModel;

    public serviceCombos: Immutable.List<ServiceOrComboTableItem<IComboOrServiceItem>>;
    public SearchText: string;
    public selectedServiceDefinitionIds: string[];
}

class UserAddNewServiceComboComponent extends React.Component<IUserAddNewServiceComboProps, UserAddNewServiceComboState> {
    private componentId = "addServicePopup";
    private saveOptionKey: string = "UserAddServiceComboGrid";

    constructor(props: IUserAddNewServiceComboProps) {
        super(props);

        const initialState = new UserAddNewServiceComboState();
        initialState.editedUser = this.props.editedUser;
        initialState.editedGroup = this.props.editedGroup;
        initialState.serviceCombos = this.props.serviceComboGridModel.get("FilteredCombosAndServices");
        initialState.SearchText = "";
        initialState.selectedServiceDefinitionIds = [];
        this.state = initialState;
    }

    public componentDidMount(): void {
        var elem = $("#" + this.componentId);
        var cnt = document.body;
        var dragOptions = {
            containment: cnt,
            handle: ".dragHandle",
            stop: function() {
                elem.draggable("destroy");
                elem.css("height", "auto");
                window.setTimeout(() => elem.draggable(dragOptions), 50);
            }
        };
        elem.draggable(dragOptions);
        $(window).trigger("resize");

        sessionStore.showGlobalOverlay(true);
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();
    }

    public componentDidUpdate(prevProps: IUserAddNewServiceComboProps): void {
        $(window).trigger("resize");

        const currentResult = this.props.serviceComboGridModel.get("FilteredCombosAndServices");
        const previousResult = prevProps.serviceComboGridModel.get("FilteredCombosAndServices");

        if (currentResult !== previousResult) {
            this.mutateState(s => {
                s.serviceCombos = currentResult;
            });
        }
    }

    public render(): JSX.Element {
        const columnsOptions = cacheStore.Helper.loadTableColumnOptionsFromSettings(this.saveOptionKey, this.getMyleTableColumnsDefaultOptions());
        const tableRenderOptions = this.loadTableRenderOptions(columnsOptions);
        const tableColumns = this.getTableColumns(columnsOptions);

        // only display elements that are not in the currentEmployeeServices
        const editedEmployeeServiceDefs = this.props.editedUser != null
            ? this.props.editedUser.ServicesCombos?.map(x => x.ServiceDefinitionId) ?? []
            : this.props.editedGroup.ServicesCombos?.map(x => x.ServiceDefinitionId) ?? [];

        // filter services - do no display combo and ad-hoc
        const services = this.props.userServiceComboGridModel.get("FilteredCombosAndServices")
            .filter(service =>
                service.IsAdHoc == false
                && editedEmployeeServiceDefs.indexOf(service.ServiceDefinitionId) == -1
            )
            .toArray()
            .filterSearch(this.state.SearchText, item => item.Name);

        const userSites = this.props.editedUser.getSites();
        const filteredComboList = services.filter(service => userSites.some(s => s.Model.Id == service.SiteId));

        return (
            <div className="popup admin-service-popup popup-with-grid" id={this.componentId}>

                <div className="portal-messages-header">
                    <div className="itemGrow dragHandle">
                        <h3> {cacheStore.GetString("AddNewComboServiceLabel")}</h3>
                    </div>
                    <div>
                        <a className="close" onClick={this.onCancelClick.bind(this)} aria-label="Close" style={{ paddingTop: "10px" }}>×</a>
                    </div>
                </div>

                <div className="p-body">
                    <div className="popup-services-flex flex-end margin-5">
                        <div>
                            <div className="flex-container search-settings">
                                <div className="flx-col a">
                                    <RefreshButton rightMargin={0} onClick={this.onRefreshClick.bind(this)} />
                                </div>
                                <div className="flx-col a">
                                    <SettingsButton rightMargin={0} onClickOperation={this.props.openSearchSettingOperation} />
                                </div>
                                <div className="flx-col c">
                                    <TextboxControl
                                        debounceMs={400}
                                        value={this.state.SearchText}
                                        onChange={this.textFilterChanged.bind(this)}
                                        style={{ marginRight: "10px", "verticalAlign": "sub" }}
                                        className="form-control primary-search"
                                        placeholder={cacheStore.GetString("SearchField")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="fxheightpopup flex-container" style={{ height: "464px" }}>

                            <MyleTable
                                TableRenderOptions={tableRenderOptions}
                                TableId="employeeAddServicesCombos_table"
                                Columns={tableColumns}
                                DataSource={filteredComboList.filter(type => type.Type == ServiceComboItemType.Service).toImmutable()}
                                RowClickOperation={null}
                                RowClickFunction={item => this.props.editedUser != null ? this.onRowClickEditedUser(item) : this.onRowClickEditedGroup(item)}
                                SaveOptionskeyTarget={this.saveOptionKey}
                                ColumnReorderTarget={MyleTableTarget.Unassigned}
                                ColumnSortTarget={MyleTableTarget.Myle_AdminService_ColumnSortClick}

                            />
                        </div>

                    </div>

                </div>
                <div className="p-footer flex-display flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            className="btn btn-default"
                            onClick={this.onCancelClick.bind(this)}
                            label={cacheStore.GetString("CancelLabel")}
                        />
                        <ButtonControl
                            className="btn btn-primary"
                            onClick={this.onAddClick.bind(this)}
                            label={cacheStore.GetString("AddLabel")}
                        />
                    </ButtonGroup>
                </div>
            </div>
        );
    }

    private getTableColumns(columnsOptions: Immutable.List<MyleTableColumnOptions>): Immutable.List<MyleTableColumn> {
        return MyleTableColumn.buildList<ServiceOrComboTableItem<IComboOrServiceItem>>(
            columnsOptions,
            column => {
                switch (column.FieldName) {
                    case "Site":
                        let defIds: string[] = [];
                        if (this.props.editedUser != null)
                            defIds = (this.state.editedUser.Model.ServicesOffered != null) ? this.state.editedUser.Model.ServicesOffered.map(x => x.ServiceDefinitionModel.Model.Id) : [];
                        else
                            defIds = (this.state.editedGroup.Model.ServicesIDsOffered != null) ? this.state.editedGroup.Model.ServicesIDsOffered.map(x => x.DefId) : [];

                        return {
                            renderCell: item => (
                                <div>
                                    <CheckboxControl
                                        id={item.ServiceDefinitionId}
                                        onChange={null}
                                        target={CheckboxTarget.Unassigned}
                                        label={null}
                                        checked={(defIds.indexOf(item.ServiceDefinitionId) != -1) ? true : false}
                                        style={{ "width": "20%", "float": "left" }}
                                    />
                                    <SpanControl text={item.Site} />
                                </div>
                            )
                        };

                    case "Service":
                        return {
                            renderCell: item => (
                                <div><SpanControl text={item.Name} /> </div>
                            )
                        };

                    case "Type":
                        return {
                            renderCell: item => (
                                <div> <SpanControl text={item.TypeString} /> </div>
                            )
                        };

                    case "Speciality":
                        return {
                            renderCell: item => (
                                <div> <SpanControl text={item.Speciality} /> </div>
                            )
                        };

                    case "Duration":
                        return {
                            renderCell: item => (
                                <div>
                                    <SpanControl text={item.Duration + " min"} />
                                </div>
                            )
                        };
                        break;
                }
            },
            false
        );
    }

    private getMyleTableColumnsDefaultOptions(): MyleTableColumnOptions[] {
        var cols: MyleTableColumnOptions[] = [];

        var c_opt0 = new MyleTableColumnOptions();
        c_opt0.HeaderText = cacheStore.GetString("SiteDLabel");
        c_opt0.FieldName = "Site";
        c_opt0.IsFixedInPlace = true;
        c_opt0.IsSortable = true;
        c_opt0.RowClickEnabled = true;
        c_opt0.SortColumn = AdminServiceGridSortColumn.Site;
        c_opt0.SortDirection = SortDirection.ASC;
        c_opt0.WidthPercentageDefault = 30;

        var c_opt1 = new MyleTableColumnOptions();
        c_opt1.HeaderText = cacheStore.GetString("NameLabel");
        c_opt1.FieldName = "Service";
        c_opt1.RowClickEnabled = true;
        c_opt1.IsSortable = true;
        c_opt1.SortColumn = AdminServiceGridSortColumn.Name;
        c_opt1.SortDirection = SortDirection.ASC;
        c_opt1.WidthPercentageDefault = 20;

        var c_opt2 = new MyleTableColumnOptions();
        c_opt2.HeaderText = cacheStore.GetString("TypeLabel");
        c_opt2.FieldName = "Type";
        c_opt2.RowClickEnabled = true;
        c_opt2.IsSortable = true;
        c_opt2.SortColumn = AdminServiceGridSortColumn.Type;
        c_opt2.SortDirection = SortDirection.ASC;
        c_opt2.WidthPercentageDefault = 10;

        var c_opt3 = new MyleTableColumnOptions();
        c_opt3.HeaderText = cacheStore.GetString("SpecialityLabel");
        c_opt3.FieldName = "Speciality";
        c_opt3.RowClickEnabled = true;
        c_opt3.IsSortable = true;
        c_opt3.SortColumn = AdminServiceGridSortColumn.Speciality;
        c_opt3.SortDirection = SortDirection.ASC;
        c_opt3.WidthPercentageDefault = 25;

        var c_opt4 = new MyleTableColumnOptions();
        c_opt4.HeaderText = cacheStore.GetString("DurationLabel");
        c_opt4.FieldName = "Duration";
        c_opt4.RowClickEnabled = true;
        c_opt4.IsSortable = true;
        c_opt4.SortColumn = AdminServiceGridSortColumn.Duration;
        c_opt4.SortDirection = SortDirection.ASC;
        c_opt4.WidthPercentageDefault = 15;

        cols.push(c_opt0);
        cols.push(c_opt1);
        cols.push(c_opt2);
        cols.push(c_opt3);
        cols.push(c_opt4);

        return cols;
    }

    private loadTableRenderOptions(columnOptions: Immutable.List<MyleTableColumnOptions>): ITableRenderOptions {
        var defaultTablePluginOptions = {
            MinColWidth: 60,
            MinTableWidth: 980,
            Cols: columnOptions.filter(x => x.IsHidden === false).map(i => i.WidthPercentage),
            FirstColumnNoDrag: false,
            LastColumnNoDrag: false,
            Autoresize: true,
            OnColumnWidthChange: null,
            HeightOffset: 65
        };

        return Immutable.fromJS(defaultTablePluginOptions);
    }

    private mutateState(mutation: (s: UserAddNewServiceComboState) => void, then: () => void = null): void {
        var s = new UserAddNewServiceComboState();
        mutation(s);
        this.setState(s, then);
    }

    private onRefreshClick(): void {
        var operation = new LocalEvent(this.props.refreshServiceOperation);
        operation.AddItem("reload", true);
        LocalEventDispatcher.dispatch(operation);
    }

    private textFilterChanged(val: string): void {
        var s = new UserAddNewServiceComboState();
        s.SearchText = val;
        this.setState(s);
    }

    private onCancelClick(): void {
        var operation = new LocalEvent(this.props.closeOperation);
        operation.AddItem("selectedServiceDefinitonIds", this.state.selectedServiceDefinitionIds);
        LocalEventDispatcher.dispatch(operation);

        this.onCancelSearchSettings();
    }

    private onAddClick(): void {
        var s = new UserAddNewServiceComboState();
        this.setState(s);
        var operation = new LocalEvent(this.props.saveOperation);
        LocalEventDispatcher.dispatch(operation);
    }

    private onRowClickEditedUser(item: ServiceOrComboTableItem<IComboOrServiceItem>): void {
        var s = new UserAddNewServiceComboState();
        s.editedUser = this.state.editedUser;
        s.selectedServiceDefinitionIds = this.state.selectedServiceDefinitionIds;

        if (s.editedUser.Model.ServicesOffered == null)
            s.editedUser.Model.ServicesOffered = [];

        let isChecked: boolean = false;

        if (s.editedUser.Model.ServicesOffered.some(x => x.ServiceDefinitionModel != null))
            isChecked = s.editedUser.Model.ServicesOffered.map(x => x.ServiceDefinitionModel.Model.Id).indexOf(item.ServiceDefinitionId) > -1;

        if (!isChecked) {
            let serviceDefinitionModel: ServiceDefinitionModel = ArrayHelper.Find(cacheStore.ServiceDefinitionCache.toArray(), (x: ServiceDefinitionModel) => x.Model.Id == item.ServiceDefinitionId);

            if (s.editedUser.Model.ServicesOffered)
                s.editedUser.Model.ServicesOffered.push(new ServiceModel(item.ServiceDefinitionId, serviceDefinitionModel));
        }
        else {
            if (s.editedUser.Model.ServicesOffered.length > 0)
                s.editedUser.Model.ServicesOffered.splice(s.editedUser.Model.ServicesOffered.map(x => x.ServiceDefinitionModel.Model.Id).indexOf(item.ServiceDefinitionId), 1);
        }

        s.selectedServiceDefinitionIds.push(item.ServiceDefinitionId);

        this.setState(s);
    }

    private onRowClickEditedGroup(item: ServiceOrComboTableItem<IComboOrServiceItem>): void {
        var s = new UserAddNewServiceComboState();
        s.editedGroup = this.state.editedGroup;

        if (s.editedGroup.Model.ServicesIDsOffered == null)
            s.editedGroup.Model.ServicesIDsOffered = [];

        let isChecked = s.editedGroup.Model.ServicesIDsOffered.map(x => x.DefId).indexOf(item.ServiceDefinitionId) > -1;

        if (!isChecked) {
            // first try to get a service with same serviceDefinition from employee service cache (in case it was removed and re-added in same ui step, it will still be cached with its serviceId)
            let service: Service = ArrayHelper.Find(cacheStore.ServicesByEmployees[s.editedUser.ContactFacetId], (x: Service) => x.DefId == item.ServiceDefinitionId);
            if (service == null) {
                service = new Service();
                service.DefId = item.ServiceDefinitionId;
                service.EmployeeId = s.editedUser.ContactFacetId;
                service.IsInactive = false;
            }

            if (s.editedGroup.Model.ServicesIDsOffered)
                s.editedGroup.Model.ServicesIDsOffered.push(service);
        }
        else {
            if (s.editedGroup.Model.ServicesIDsOffered.length > 0)
                s.editedGroup.Model.ServicesIDsOffered.splice(s.editedGroup.Model.ServicesIDsOffered.map(x => x.DefId).indexOf(item.ServiceDefinitionId), 1);
        }

        this.setState(s);
    }

    private onCancelSearchSettings(): void {
        let operation = new LocalEvent(this.props.closeSearchSettingOperation);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { UserAddNewServiceComboComponent };
